import LightTheme from './light'
import DarkTheme from './dark'
import ExtraDarkTheme from './extradark'
import GreenTheme from './green'
import SpotifyTheme from './spotify'
import LigeraTheme from './ligera'
import MonokaiTheme from './monokai'
import ElectricPurpleTheme from './electricPurple'
import NordTheme from './nord'
import GruvboxDarkTheme from './gruvboxDark'

export default {
  // Classic default themes
  LightTheme,
  DarkTheme,

  // New themes should be added here, in alphabetic order
  ElectricPurpleTheme,
  ExtraDarkTheme,
  GreenTheme,
  GruvboxDarkTheme,
  LigeraTheme,
  MonokaiTheme,
  NordTheme,
  SpotifyTheme,
}
